var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2559 1.07741C11.9305 0.751969 11.4029 0.751969 11.0774 1.07741L1.91076 10.2441C1.75448 10.4004 1.66669 10.6123 1.66669 10.8333V14.1667C1.66669 14.6269 2.03978 15 2.50002 15H5.83335C6.05437 15 6.26633 14.9122 6.42261 14.7559L15.5893 5.58925C15.9147 5.26381 15.9147 4.73618 15.5893 4.41074L12.2559 1.07741ZM3.33335 13.3333V11.1785L11.6667 2.84517L13.8215 5L5.48818 13.3333H3.33335ZM2.50002 17.5C2.03978 17.5 1.66669 17.8731 1.66669 18.3333C1.66669 18.7936 2.03978 19.1667 2.50002 19.1667H17.5C17.9603 19.1667 18.3334 18.7936 18.3334 18.3333C18.3334 17.8731 17.9603 17.5 17.5 17.5H2.50002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.02dbe4a02058cf29f6167255f6fbdd7b.svg";
export { ForwardRef as ReactComponent };